export const bodyShoppingCart = data => ({
  location_id: data.locationId,
  description: data.description,
  customer_id: data.customerId,
  shipping_address: { ...data.shippingAddress, country: 'Brazil' },
  origin_source: data.originSource
})
